import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: absolute;
  background-color: #fff;
  height: 100%;
  width: 100%;
  z-index: 2;
  top: 0;
  left: 0;
  display: flex;
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 1.4em;
  top: 6px;
  right: 15px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.phone`
    background-color: #fff;
    top: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 5px;
  `}
`;

export const Avatar = styled.div`
  display: flex;
  width: 130px;
  position: relative;
  overflow: hidden;
  width: 150px;
  justify-content: center;
  align-items: center;

  ${mediaMaxWidth.phone`
    margin: 10px auto;
  `}
`;

export const AvatarPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e4e5e7;
  border-radius: 4px;
  width: 130px;
  height: 130px;

  svg {
    font-size: 2em;
    color: #fff;
  }
`;

export const AvatarImage = styled.img`
  width: 130px;
  height: 130px;
  object-fit: cover;
  border-radius: 4px;
`;

export const Preview = styled.div`
  position: absolute;
  bottom: 10px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  width: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-transform: capitalize;

  ${mediaMaxWidth.phone`
    bottom: 0;
  `}
`;

export const Form = styled.form`
  display: flex;
  flex: 1;

  ${mediaMaxWidth.phone`
    flex-direction: column;
  `}
`;

export const Actions = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  justify-content: flex-start;
  padding: 10px 0;
  justify-content: center;
  align-items: center;
  margin-right: 100px;

  ${mediaMaxWidth.phone`
    margin-right: 0;
    height: 200px;
    flex: unset;
  `}
`;

export const UploadInputWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: inline-block;
`;

export const UploadInput = styled.input`
  font-size: 100px;
  position: absolute;
  left: -32px;
  top: 0;
  opacity: 0;
  height: 23px;
  width: 140px;
  cursor: pointer;
`;

export const UploadButton = styled.button`
  border: none;
  color: #333;
  text-transform: capitalize;
  background-color: unset;
  font-weight: bold;
`;

export const Action = styled.div`
  background-color: #e4e5e7;
  width: max-content;
  color: #333;
  border-radius: 4px;
  padding: 3px 10px;
  font-weight: 700;
  font-size: 0.9em;
  cursor: pointer;
  align-items: center;
  text-transform: capitalize;
  height: 26px;
  display: flex;

  svg {
    margin-right: 10px;
  }

  &:hover {
    background-color: ${(props) => props.upload && "#27ae60"};
    background-color: ${(props) => props.delete && "#f84c4c"};
    color: #fff;

    button {
      color: #fff;
    }
  }

  ${mediaMaxWidth.phone`
    height: 35px;
    padding: 5px 15px;
    margin-bottom: ${(props) => props.upload && "20px"};
  `}
`;

export const SaveButton = styled.button`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-weight: bold;
  color: #fff !important;
  padding: 5px 25px;
  cursor: pointer;
  background: #79D9D9;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 85px;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
  }

  ${mediaMaxWidth.phone`
    right: 0;
    left: 0;
    margin: 0 auto;
  `}
`;

export const FileSizeError = styled.div`
  font-size: 12px;
  color: #ff0000;
  position: absolute;
  margin-top: 22px;
`;
